"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.908 7.4168C4.251 8.0535 4 8.907 4 9.7563c0 .9089.3343 1.7489.9985 2.3542.6566.5984 1.5482.8895 2.534.8895.9868 0 1.8708-.2922 2.5154-.9024.6487-.6142.9521-1.4538.9521-2.3413 0-.8787-.2911-1.7214-.9367-2.3422C9.4199 6.7954 8.5322 6.5 7.5325 6.5c-1.0545 0-1.9706.283-2.6246.9168zM6.2998 8.853c.1706-.1654.5208-.3529 1.2326-.3529.6106 0 .9567.175 1.1445.3557.1856.1784.323.4639.323.9006 0 .4278-.1381.71-.3271.8889C8.4799 10.828 8.13 11 7.5325 11c-.5987 0-.9733-.1731-1.1868-.3677-.206-.1877-.3457-.4697-.3457-.876 0-.466.132-.7407.2999-.9033z"
  }), _react.default.createElement("path", {
    d: "M12 14.4999V13.5c0-1.5406 1.1403-2.6803 2.3894-3.3742C15.6792 9.4093 17.3496 9 19 9h3v2h-3c-1.3495 0-2.679.3407-3.6393.8741-.3684.2047-.65.4167-.8587.6259H22v2l-10-.0001zM4 16v-2H2v2c0 2.2091 1.7909 4 4 4h16v-2H6c-1.1046 0-2-.8954-2-2z"
  })];
};

exports.default = _default;